/**
 * Slice 19d — thin composer over the list (collapsed `<details>`) and the
 * create/edit editor. Clicking a row in the list opens it in the editor;
 * the editor toggles between create mode (no editingTemplateId) and edit
 * mode (an existing template id).
 */
import type {
  AdsAssistantCategoryRow,
  AdsAssistantPostTagDefRow,
  AdsAssistantTemplateRow,
} from "@/lib/adsAssistantClient";
import { AdsLibraryTemplateEditor } from "@/components/ads-assistant/AdsLibraryTemplateEditor";
import { AdsLibraryTemplatesList } from "@/components/ads-assistant/AdsLibraryTemplatesList";
import type { LibraryTemplateEditor } from "@/components/ads-assistant/useAdsAssistantLibraryTemplateEditor";

type Props = {
  canEdit: boolean;
  scopedOrgId: string | null;
  categories: AdsAssistantCategoryRow[];
  templates: AdsAssistantTemplateRow[];
  postTagDefs: AdsAssistantPostTagDefRow[];
  editor: LibraryTemplateEditor;
  setError: (e: string | null) => void;
  setBanner: (b: string | null) => void;
  load: () => Promise<void>;
};

export function AdsLibraryTemplatesPanel(props: Props) {
  const { canEdit, scopedOrgId, categories, templates, postTagDefs, editor, setError, setBanner, load } = props;
  return (
    <div className="space-y-3">
      <AdsLibraryTemplatesList
        templates={templates}
        canEdit={canEdit}
        postTagDefs={postTagDefs}
        editingTemplateId={editor.editingTemplateId}
        onEdit={editor.openTemplateForEdit}
        setError={setError}
        setBanner={setBanner}
        load={load}
      />
      <AdsLibraryTemplateEditor
        canEdit={canEdit}
        scopedOrgId={scopedOrgId}
        categories={categories}
        templates={templates}
        postTagDefs={postTagDefs}
        editor={editor}
        setError={setError}
        setBanner={setBanner}
        load={load}
      />
    </div>
  );
}
